import Space from "antd/lib/space";
import Radio from "antd/lib/radio";
import Form from "antd/lib/form";
import React from "react";
import styled from "styled-components";

import { AppCard } from "components/card";
import { Colors } from "helpers/colors";
import { Platform } from "constants/roles";

interface WeightGainSectionProps {
  readonly currentPage: number;
}

export const WeightGainSection: React.FC<WeightGainSectionProps> = ({
  currentPage
}) => {
  const params = new URLSearchParams(window.location.search);
  const platform = params.get("platform");
  return (
    <>
      {currentPage === 14 && (
        <Space direction="vertical" size={20}>
          <Space direction="vertical" size={20}>
            <AppCard
              cardHeight="fit-content"
              cardWidth={
                platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
              }
            >
              <Space
                direction="vertical"
                size={20}
                style={{ width: "100%", padding: "10px" }}
              >
                <DisclaimerTitle>WEIGHT GAIN</DisclaimerTitle>
                <CardTitle>
                  How much weight do you gain between dialysis treatments?
                  <AsteriskStyle> *</AsteriskStyle>
                </CardTitle>
                <FormItemStyle
                  name="How much weight do you gain"
                  label=""
                  rules={[
                    {
                      required: true
                    }
                  ]}
                  initialValue={""}
                >
                  <Radio.Group
                    value={localStorage.getItem("howMuchWeightDoYouGain")}
                    onChange={e => {
                      localStorage.setItem(
                        "howMuchWeightDoYouGain",
                        e.target.value
                      );
                    }}
                  >
                    <Space direction="vertical">
                      <Radio value={"None"}>None</Radio>
                      <Radio value={"Less than 2 kilograms (4 pounds)"}>
                        Less than 2 kilograms (4 pounds)
                      </Radio>
                      <Radio value={"2 - 3 kilograms (4 - 7 pounds)"}>
                        2 - 3 kilograms (4 - 7 pounds)
                      </Radio>
                      <Radio value={"3 - 5 kilograms (7 - 11 pounds)"}>
                        3 - 5 kilograms (7 - 11 pounds)
                      </Radio>
                      <Radio value={"More than 5 kilograms"}>
                        More than 5 kilograms
                      </Radio>
                    </Space>
                  </Radio.Group>
                </FormItemStyle>
              </Space>
            </AppCard>
          </Space>
        </Space>
      )}
      {currentPage === 15 && (
        <Space direction="vertical" size={20}>
          <AppCard
            cardHeight="fit-content"
            cardWidth={
              platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
            }
          >
            <Space
              direction="vertical"
              size={20}
              style={{ width: "100%", padding: "10px" }}
            >
              <DisclaimerTitle>SYMPTOM ALERT</DisclaimerTitle>
              <SymptomAlert>
                Please discuss your symptoms of weight gain with your nurse or
                doctor and dietician, regarding dietary sodium restriction, and
                other treatment changes
              </SymptomAlert>
            </Space>
          </AppCard>
        </Space>
      )}
    </>
  );
};

const DisclaimerTitle = styled.div`
  width: 100%;
  padding: 8px 8px 8px 20px;
  margin-left: -25px;
  background: ${Colors.DodgerBlue};
  font-size: 18px;
  font-family: sans-serif;
  border-radius: 8px 8px 0px 0px;
  color: white;
  position: absolute;
  top: 0;
`;

const FormItemStyle = styled(Form.Item)`
  margin-bottom: 0px;
`;

const AsteriskStyle = styled.span`
  font-weight: 800;
  color: red;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-family: sans-serif;
`;

const SymptomAlert = styled.div`
  font-size: 16px;
  font-family: sans-serif;
  margin-top: 15px;
`;
